<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Cotton & Basic Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Cotton & Basic Line" file="cotton">
                Single/Double Knit, Rib, Terry, Tricot with BCI, US, Organic cotton and blended fiber. From premium cotton fabrics to affordable options. We produce any basic knit item, with reasonable price & without cotton origin problem.
            </sub-product>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped></style>
